import useShareSheetV2 from 'hooks/useShareSheetV2'
import { Subheader } from './Subheader/Subheader'
import { ShareSheetProps } from './Types'
import { RecipientSelector } from './RecipientSelector'
import Styles from './ShareSheet.module.scss'

export const InviteUsers = ({ file }: ShareSheetProps) => {
  const { asset } = useShareSheetV2(file)

  return (
    <div className={Styles.inviteUsers}>
      <RecipientSelector file={file} showLabel={false} />
      <Subheader type={asset?.type} file={file} />
    </div>
  )
}
